import { Component, Input, inject, computed, signal } from '@angular/core';
import { BreadcrumbService, IBreadcrumbItem } from './breadcrumb.service';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'lc-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    standalone: true,
    imports: [CommonModule, RouterModule],
})
export class BreadcrumbComponent {
    private readonly breadcrumbService = inject(BreadcrumbService);

    // Input opcional para permitir sobrescrever breadcrumb manualmente
    @Input() set items(value: IBreadcrumbItem[]) {
        if (value && value.length > 0) {
            // Se items são fornecidos via input, usa eles
            this.useManualItems.set(true);
            this.manualItems.set(value);
        }
    }

    // Signal para controlar se deve usar breadcrumb automático ou manual
    private readonly useManualItems = signal<boolean>(false);
    private readonly manualItems = signal<IBreadcrumbItem[]>([]);

    // Computed signal para os itens do breadcrumb
    readonly breadcrumbItems = computed(() => {
        if (this.useManualItems()) {
            return this.manualItems();
        }
        return this.breadcrumbService.items();
    });
}
